import { useContext, useEffect, useState } from "react";
import "../App.css";
import { StateContext } from "../context/StateContext";
import { useRequest } from "../hooks/useRequest";
import UploadFile from "./UploadFile";
import LoadingComponent from "./LoadingComponent";
import Response from "./Response";
import { PanelHeader, PanelHelp } from "./ContentsStyled";
import labels from "../translation/index.json";

const Contents = () => {
  useRequest();
  const appState = useContext(StateContext);
  const { status, responseData, requestParameters } = appState.currentState;
  const renderComponent = () => {
    switch (status) {
      case "provide-file":
        return <UploadFile />;
      case "request-in-progress":
        return <LoadingComponent />;
      case "request-complete":
        if (responseData) {
          return <Response responseData={responseData} />;
        }
    }
  };
  const getType = (res: string) => {
    switch (res) {
      case "activation":
        return "- " + labels.activate;
      case "deactivation":
        return "- " + labels.deactivate;
      default:
        return "";
    }
  };

  const handleHelpClick = () => {
    window.open(
      labels.helpCta.replace(
        "$1",
        process.env.REACT_APP_RPM_VERSION_NUMBER || "v3.9.1",
      ),
      "_blank",
    );
  };

  return (
    <>
      <PanelHeader>
        <div role="heading" aria-level={1}>
          {labels.offlineLicenseTool}{" "}
          {getType(requestParameters?.requestType || "")}
        </div>
        <PanelHelp tabIndex={0} onClick={handleHelpClick}>
          Help
        </PanelHelp>
      </PanelHeader>
      {renderComponent()}
    </>
  );
};
export default Contents;
